@if (formConfigs) {
  <form class="dialog-form position-relative">
    @if (formConfigs.length) {
      <div class="row">
        <app-form
          [formConfig]="formConfigs"
          [validationEmit]="itemsFormValidationEmit"
          [hasButton]="false"
          (onChange)="formValuesChanged($event)"
          [validationErrors]="validationErrors"
          (onSubmit)="submitForm($event)"
        >
        </app-form>
      </div>
    }
    @if (modalData.data?.visible) {
      <div class="dialog-footer d-flex justify-content-between">
        <button type="button" [disabled]="isLoadingAddEditItem" class="btn btn-outline-main" (click)="onClose()">
          {{ 'GENERAL.CANCEL' | translate }}
        </button>
        <button type="button" [disabled]="isLoadingAddEditItem" class="btn btn-solid-main" (click)="emitValidation()">
          @if (isLoadingAddEditItem) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ model.id ? ('GENERAL.UPDATE' | translate) : ('GENERAL.CREATE' | translate) }}
        </button>
      </div>
    }
  </form>
}
